import * as React from 'react';
import classNames from 'classnames';
import './summary-section.scss';

const gridStyles = ({ columns, styles = {} }: { columns?: string; styles?: React.CSSProperties }) => {
  return {
    ...styles,
    gridTemplateColumns: columns,
  };
};

interface SummaryGridItemProps {
  styles?: React.CSSProperties;
  children: React.ReactNode;
  testId?: string;
  className?: string;
}

export const SummaryGridItem = ({ className, children, styles, testId }: SummaryGridItemProps) => {
  return (
    <div className={classNames(className, 'summary-grid-item')} style={styles} data-testid={testId}>
      {children}
    </div>
  );
};

/*
    Consistent Label w/ Large Text Call Out
*/

export const SummaryGridCalloutItem = ({ children, styles, testId }: SummaryGridItemProps) => {
  return (
    <div className="summary-grid-item call-out" style={styles} data-testid={testId}>
      {children}
    </div>
  );
};

interface SummarySectionProps {
  testId?: string;
  children: React.ReactNode;
  columns?: string;
  className?: string;
  styles?: React.CSSProperties;
}

export const SummarySection: React.FC<SummarySectionProps> = ({
  children,
  columns,
  className,
  testId,
  styles,
}: SummarySectionProps) => {
  return (
    <div
      data-testid={testId ?? `summary-section`}
      className={classNames(className, 'summary-section-wrapper')}
      style={gridStyles({ columns, styles })}
    >
      {children}
    </div>
  );
};
